import styled from 'styled-components';

import { theme } from '@mi-front/ui';

export const Wrapper = styled.div`
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  line-height: 1.25rem;
  text-align: left;
`;
export const Pre = styled.div`
  color: ${theme.gray500};
  text-transform: uppercase;
  font-size: 0.6rem;
`;
export const Title = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
`;
export const SubTitle = styled.div`
  font-size: 0.7rem;
`;
export const Score = styled.div`
  margin-bottom: 0.25rem;
`;
